const TTL_MS = 90 * 1000;
const inflight = new Map();

const cacheKey = (shopId) => `visitor_shop_products_prefetch_${shopId}`;

export const readShopProductsPrefetch = (shopId) => {
  if (!shopId || typeof window === "undefined") {
    return null;
  }

  try {
    const raw = sessionStorage.getItem(cacheKey(shopId));
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    if (!parsed?.ts || Date.now() - parsed.ts > TTL_MS) {
      sessionStorage.removeItem(cacheKey(shopId));
      return null;
    }

    return parsed.data || null;
  } catch {
    return null;
  }
};

export const writeShopProductsPrefetch = (shopId, data) => {
  if (!shopId || !data || typeof window === "undefined") {
    return;
  }

  try {
    sessionStorage.setItem(
      cacheKey(shopId),
      JSON.stringify({
        ts: Date.now(),
        data,
      })
    );
  } catch {
    // ignore quota errors
  }
};

export const prefetchShopProducts = (axios, baseUrl, shopId) => {
  if (!shopId || readShopProductsPrefetch(shopId) || inflight.has(shopId)) {
    return;
  }

  const request = axios
    .post(
      `${baseUrl}/shops/${shopId}/products?page=1&count=20`,
      { filter: 1 },
      { headers: { "Content-Type": "application/json" } }
    )
    .then((response) => {
      if (response?.data) {
        writeShopProductsPrefetch(shopId, response.data);
      }
    })
    .catch(() => {})
    .finally(() => {
      inflight.delete(shopId);
    });

  inflight.set(shopId, request);
};
